import { render, staticRenderFns } from "./authLayout.vue?vue&type=template&id=af8c530e&scoped=true&"
import script from "./authLayout.vue?vue&type=script&lang=js&"
export * from "./authLayout.vue?vue&type=script&lang=js&"
import style0 from "./authLayout.vue?vue&type=style&index=0&id=af8c530e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8c530e",
  null
  
)

export default component.exports